import React from 'react';
import { Chip } from '../../../../components/immobilien/ui';
import { eur } from '../../../../lib/immobilien/format';
import { STATUS_ANZEIGE, statusLabel, type MieterZeile } from '../../../../lib/mieter/liste';
import { MieterAvatar, saldoAnzeige } from './MieterKachel';

const SPALTEN = 'minmax(150px,1.4fr) minmax(120px,1fr) 124px 76px 76px 96px 104px 108px';

/** Listenansicht (README §5.1): Name+E-Mail · Einheit+Objekt · Telefon · Kalt · NK · Gesamt · Mietkonto · Status. */
export function MieterTabelle({ zeilen, onOeffnen }: { zeilen: readonly MieterZeile[]; onOeffnen: (id: string) => void }) {
  const tastatur = (id: string) => (e: React.KeyboardEvent<HTMLDivElement>) => {
    if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); onOeffnen(id); }
  };
  return (
    <section className="immo-glas overflow-x-auto" style={{ borderRadius: 26, padding: 6 }} aria-label="Mieter als Liste">
      <div role="table" className="flex flex-col" style={{ minWidth: 920 }}>
        <div role="row" className="grid"
          style={{ gridTemplateColumns: SPALTEN, gap: 10, padding: '12px 14px', fontSize: 11, fontWeight: 800, letterSpacing: '0.05em', textTransform: 'uppercase', color: 'var(--ink3)' }}>
          <span role="columnheader">Name</span><span role="columnheader">Einheit</span><span role="columnheader">Telefon</span>
          <span role="columnheader" style={{ textAlign: 'right' }}>Kalt</span><span role="columnheader" style={{ textAlign: 'right' }}>NK</span>
          <span role="columnheader" style={{ textAlign: 'right' }}>Gesamt</span><span role="columnheader" style={{ textAlign: 'right' }}>Mietkonto</span>
          <span role="columnheader" style={{ textAlign: 'right' }}>Status</span>
        </div>
        {zeilen.map(z => {
          const st = STATUS_ANZEIGE[z.status];
          const saldo = saldoAnzeige(z.saldo);
          return (
            <div key={z.id} role="row" tabIndex={0} aria-label={`${z.name} öffnen`} onClick={() => onOeffnen(z.id)} onKeyDown={tastatur(z.id)}
              className="immo-hover-flaeche grid items-center cursor-pointer"
              style={{ gridTemplateColumns: SPALTEN, gap: 10, padding: '10px 14px', borderRadius: 16, fontSize: 13 }}>
              <span role="cell" className="flex items-center min-w-0" style={{ gap: 10 }}>
                <MieterAvatar z={z} groesse={32} />
                <span className="flex flex-col min-w-0">
                  <b className="truncate" style={{ fontWeight: 800 }}>{z.name}</b>
                  <span className="truncate" style={{ fontSize: 11, color: 'var(--ink3)' }}>{z.email || '–'}</span>
                </span>
              </span>
              <span role="cell" className="flex flex-col min-w-0">
                <span className="truncate" style={{ fontWeight: 600 }}>{z.einheit || '–'}</span>
                <span className="truncate" style={{ fontSize: 11, color: 'var(--ink3)' }}>{z.objektName}</span>
              </span>
              <span role="cell" className="immo-zahl truncate" style={{ color: 'var(--ink2)' }}>{z.telefon || '–'}</span>
              <span role="cell" className="immo-zahl" style={{ textAlign: 'right' }}>{eur(z.kalt, { nachkomma: 0 })}</span>
              <span role="cell" className="immo-zahl" style={{ textAlign: 'right', color: 'var(--ink2)' }}>{eur(z.nk, { nachkomma: 0 })}</span>
              <b role="cell" className="immo-zahl" style={{ textAlign: 'right', fontWeight: 800 }}>{eur(z.gesamt)}</b>
              <b role="cell" className="immo-zahl" title={saldo.titel} style={{ textAlign: 'right', fontWeight: 800, color: saldo.farbe }}>{saldo.text}</b>
              <span role="cell" className="flex justify-end"><Chip ton={st.ton} groesse="xs">{statusLabel(z.status, z.ehemalig)}</Chip></span>
            </div>
          );
        })}
      </div>
    </section>
  );
}
